import DashboardStatistics from './DashboardStatistics'
export default DashboardStatistics
